import { render } from "./App.vue?vue&type=template&id=6b93e59f&lang=pug"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=6b93e59f&lang=less"
script.render = render

export default script